// extracted by mini-css-extract-plugin
export default {"input__title":"NewGroup_input__title__4mYA9 font-sm-medium","input__icon":"NewGroup_input__icon__IPwSk","questionIcon__tooltipLink":"NewGroup_questionIcon__tooltipLink__+lAi6"};